module.exports = __webpack_public_path__ + "media/scripts/pages/join/assets/media/bts/bts-image@1x-27fcfa1e3251bb5431a62a996f4eeb89.jpg";